import { render, staticRenderFns } from "./bankPayments.vue?vue&type=template&id=8c51eb3c"
import script from "./bankPayments.vue?vue&type=script&lang=js"
export * from "./bankPayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports